'use client';

import type { CSSProperties } from 'react';
import { cn } from '@/lib/utils';
import { getEffectPreset, normalizeEffectId, type EditorEffectId } from '@/lib/editor/effects';

interface EditorEffectVisualProps {
  effect: EditorEffectId | string;
  color?: string;
  opacity?: number;
  className?: string;
  compact?: boolean;
}

export function EditorEffectVisual({
  effect,
  color,
  opacity = 1,
  className,
  compact = false,
}: EditorEffectVisualProps) {
  const effectId = normalizeEffectId(effect);
  const preset = getEffectPreset(effectId);
  const style = {
    '--editor-effect-color': color || preset.defaultColor,
    opacity,
    mixBlendMode: preset.blendMode,
  } as CSSProperties;

  return (
    <span
      aria-hidden="true"
      data-editor-effect={effectId}
      data-compact={compact ? 'true' : 'false'}
      className={cn('editor-effect-visual pointer-events-none absolute inset-0 overflow-hidden', className)}
      style={style}
    >
      <span className="editor-effect-shape editor-effect-shape-a absolute inset-0" />
      <span className="editor-effect-shape editor-effect-shape-b absolute inset-0" />
    </span>
  );
}
